import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { DetailColumn, ReportColumn, ReportRow } from "../../../api/types/widgetTypes";
import { getReportColumnAlignment } from "./tabularReportGridHelpers";

interface Props {
  row: ReportRow;
  columns: ReportColumn[];
  columnWidths: Record<string, number>;
  detailColumns?: DetailColumn[];
}

const TabularReportRowDetail = ({ row, columns, columnWidths, detailColumns }: Props) => {
  if (!row.detailRows?.length) {
    return null;
  }

  return (
    <TableContainer>
      <Table
        sx={() => ({
          "& .MuiTableCell-root": {
            px: 1.25,
            height: 32,
            borderBottomStyle: "dashed",
          },
          "& .MuiTableRow-root": {
            "&:last-child": {
              td: {
                borderBottom: 0,
              },
            },
          },
        })}
      >
        <TableBody>
          {row.detailRows.map((detailRow) => (
            <TableRow key={detailRow.id}>
              <TableCell sx={{ width: 50 }} />
              {columns.map((column) => {
                const cellKey = detailColumns?.find((dc) => dc.alignToColumnId === column.id)?.id ?? column.id;
                return (
                  <TableCell
                    key={column.id}
                    align={getReportColumnAlignment(column)}
                    sx={{ width: columnWidths[column.id], maxWidth: columnWidths[column.id] }}
                  >
                    <TypographyTooltipEllipsis
                      text={detailRow.cells[cellKey]?.formattedValue ?? ""}
                      typographyProps={{ color: "textSecondary" }}
                    />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TabularReportRowDetail;
